"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampNow = void 0;
var JSONSignedCertificate_1 = __importStar(require("../lib/JSONSignedCertificate"));
var Authority_1 = __importDefault(require("../lib/Authority"));
var CertValidationError_1 = require("./CertValidationError");
/**
 * Class meant to be extended when developing the authority's server.
 * Will have access to the private key, and thus will be able to sign
 * certificate requests Can be combined with an Authority Client if it needs to
 * be used to issue n level certificate (when the server is not considered a
 * root authority)
 *
 * All method with the API @tag are the helper functions that should be used by
 * the extending class.
 * All abstract class (prefixed with db) must be extended to provided interface
 * with persistent storage of choice
 */
var AbstractAuthorityServer = /** @class */ (function (_super) {
    __extends(AbstractAuthorityServer, _super);
    function AbstractAuthorityServer(issuer) {
        var _this = _super.call(this, issuer) || this;
        _this._keys = {};
        _this._pub_keys = {};
        _this._primary_keyid = null;
        _this._jsc_writer = null;
        _this._max_lifespan = 90 * 24 * 60 * 60; // 90 days
        return _this;
    }
    Object.defineProperty(AbstractAuthorityServer.prototype, "max_lifespan", {
        set: function (value_in_seconds) {
            this._max_lifespan = value_in_seconds;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the keys to be used here.
     * @param pair key pair to add
     * @param primary [optional] will use this key to sign the certificate
     * request if set to true (or on the first call)
     */
    AbstractAuthorityServer.prototype.addKeyPair = function (pair, primary) {
        if (primary === void 0) { primary = false; }
        this._keys[pair.keyid] = { pair: pair };
        if (this._primary_keyid === null || primary) {
            this._primary_keyid = pair.keyid;
            this._jsc_writer = new JSONSignedCertificate_1.JSCWriter(pair.prv, this.issuer, this._max_lifespan);
        }
    };
    AbstractAuthorityServer.prototype.addPublicKey = function (pub) {
        this._pub_keys[pub.keyid] = { pub: pub };
    };
    /**
     * Since the keys are kept in this class, this is a helper function that
     * will return a key based of it's id. Provided as a helper function only.
     * @param keyid id of the key ot obtain
     */
    AbstractAuthorityServer.prototype.getPublicKey = function (keyid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (keyid in this._keys) {
                    return [2 /*return*/, this._keys[keyid].pair.pub];
                }
                throw new Error('Invalid key id');
            });
        });
    };
    /**
     * Similar to getPublicKey, helper function to retrieve all defined public
     * keys
     * @tag API
     */
    AbstractAuthorityServer.prototype.getAllPublicKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keys, keyid, keyid;
            return __generator(this, function (_a) {
                keys = {};
                for (keyid in this._keys) {
                    keys[keyid] = this._keys[keyid].pair.pub;
                }
                for (keyid in this._pub_keys) {
                    keys[keyid] = this._pub_keys[keyid].pub;
                }
                return [2 /*return*/, keys];
            });
        });
    };
    /**
     * This will only sign the certificate, adding the identity to it.
     * the identity.sub value must match the jcr.sub
     * Any aditional field will be added to the .idt field of the signed
     * certificate
     *
     * The identify MUST have been confirmed by the extending class
     * @tag API
     *
     * @param jcr the certificate request to sign
     * @param identity The confirmed identity of the user
     */
    AbstractAuthorityServer.prototype.signCertificate = function (jcr, identity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!jcr.sub) {
                            throw new CertValidationError_1.CertValidationError('Certificate request does not include identity');
                        }
                        if (identity.sub !== jcr.sub) {
                            throw new CertValidationError_1.CertValidationError('Provided identity and certificate identity does not match');
                        }
                        return [4 /*yield*/, jcr.verify_signature()];
                    case 1:
                        if (!(_a.sent())) {
                            throw new CertValidationError_1.CertValidationError('Invalid signature');
                        }
                        return [4 /*yield*/, this.signCertificateWithoutValidation(jcr, identity)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This method will sign a certificate, without checking the identity. It is
     * expected from the calling code to have made such validations beforehand
     */
    AbstractAuthorityServer.prototype.signCertificateWithoutValidation = function (jcr, identity) {
        return __awaiter(this, void 0, void 0, function () {
            var jsc_encoded, jsc, stored;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._jsc_writer === null) {
                            throw new Error('No writer defined found');
                        }
                        return [4 /*yield*/, this._jsc_writer.sign(jcr, identity, null, undefined, {
                                body_kid: jcr.body.lightweight,
                                header_alg: jcr.body.lightweight,
                                header_kid: false,
                            }, jcr.body.compressed)];
                    case 1:
                        jsc_encoded = _a.sent();
                        jsc = new JSONSignedCertificate_1.default(jsc_encoded);
                        return [4 /*yield*/, this.dbStoreCertificate(jsc.certificate_id, identity, jsc.encoded, 
                            // add a couple days to pad for unexpected clock issues. this field
                            // define the expiration time in storage, not the validity of the
                            // certificate
                            jsc.body.exp + 48 * 60 * 60)];
                    case 2:
                        stored = _a.sent();
                        if (!stored) {
                            throw new Error('Error occured while storing the certificate, aborting');
                        }
                        return [2 /*return*/, jsc_encoded];
                }
            });
        });
    };
    /**
     * Will confirm that the identity used has the right to revoke the
     * certificate, then will issue the command to revoke it.
     * @tag API
     *
     * @param certificate_id unique id of the certificate to revoke
     * @param identity The identity of the user asking for revocation
     */
    AbstractAuthorityServer.prototype.revokeCertificate = function (certificate_id, identity) {
        return __awaiter(this, void 0, void 0, function () {
            var jsc_encoded, jsc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dbGetCertificateById(certificate_id)];
                    case 1:
                        jsc_encoded = _a.sent();
                        if (jsc_encoded === null) {
                            return [2 /*return*/, false];
                        }
                        jsc = new JSONSignedCertificate_1.default(jsc_encoded);
                        if (identity.sub !== jsc.sub) {
                            throw new Error('Identity does not have authority to revoke this certificate');
                        }
                        return [4 /*yield*/, this.dbRevokeCertificate(certificate_id)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AbstractAuthorityServer;
}(Authority_1.default));
exports.default = AbstractAuthorityServer;
var Timestamp_1 = require("../lib/Timestamp");
Object.defineProperty(exports, "TimestampNow", { enumerable: true, get: function () { return Timestamp_1.now; } });
